import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import adminAPI from '../../Services/Admin/adminAPI';

const PostNomenclatureCard = ({ open, handleClose }) => {
    const [nomenclature, setNomenclature] = useState({
        name: '',
        speciality: '',
        codeAmbulant: '',
        codeHospitalisation: '',
        n: '',
        type: '',
        subType: '',
    });

    const [isLoading, setIsLoading] = useState(false);

    const specialities = [
        { value: '', label: 'Sélectionnez une spécialité' },
        { value: 'ortho', label: 'Chirurgie orthopédique' },
        { value: 'dig', label: 'Chirurgie digestive' },
        { value: 'general', label: 'Chirurgie générale' },
        { value: 'uro', label: 'Chirurgie urologique' },
        { value: 'vasc', label: 'Chirurgie vasculaire' },
        { value: 'thor', label: 'Chirurgie thoracique' },
        { value: 'plastic', label: 'Chirurgie plastique' },
        { value: 'neuro', label: 'Neurochirurgie' },
        { value: 'transp', label: 'Transplantation' }
    ];

    const types = [
        { value: "2", title: "Traumatologie" },
        { value: "1", title: "Elective" },
    ];

    const subTypes = [
        { value: "", title: "Aucune" },
        { value: "shoulder", title: "Épaule" },
        { value: "humerus", title: "Humérus" },
        { value: "elbow", title: "Coude" },
        { value: "forearm", title: "Avant-bras" },
        { value: "wristhand", title: "Poignet-Main" },
        { value: "back", title: "Rachis" },
        { value: "pelvic", title: "Bassin" },
        { value: "hip", title: "Hanche" },
        { value: "proximalFemur", title: "Fémur proximal" },
        { value: "midFemur", title: "Diaphyse fémorale" },
        { value: "distalFemur", title: "Fémur distal" },
        { value: "knee", title: "Genou" },
        { value: "limb", title: "Jambe" },
        { value: "ankle", title: "Cheville" },
        { value: "foot", title: "Pied" },
    ];

    const handleChange = (event) => {
        const { name, value } = event.target;
        setNomenclature({
            ...nomenclature,
            [name]: value,
        });
    };

    const handleSubmit = async () => {
        setIsLoading(true);
        try {
            await adminAPI.createNomenclature(nomenclature);
            handleClose();
        } catch (error) {
            console.error('Erreur lors de la création de la nomenclature:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Inscrivez les informations</DialogTitle>
            <DialogContent>
                <TextField
                    label="Intervention"
                    name="name"
                    value={nomenclature.name}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                />
                
                <FormControl fullWidth margin="dense">
                    <InputLabel>Spécialité</InputLabel>
                    <Select
                        name="speciality"
                        value={nomenclature.speciality}
                        onChange={handleChange}
                    >
                        {specialities.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField
                    label="Code ambulant"
                    name="codeAmbulant"
                    value={nomenclature.codeAmbulant}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                />
                
                <TextField
                    label="Code hospitalisation"
                    name="codeHospitalisation"
                    value={nomenclature.codeHospitalisation}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                />

                <TextField
                    label="N"
                    name="n"
                    value={nomenclature.n}
                    onChange={handleChange}
                    fullWidth
                    margin="dense"
                />

                {nomenclature.speciality === "ortho" && (
                    <FormControl fullWidth margin="dense">
                        <InputLabel>Type</InputLabel>
                        <Select
                            name="type"
                            value={nomenclature.type}
                            onChange={handleChange}
                        >
                            {types.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.title}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}

                {nomenclature.speciality === "ortho" && (
                    <FormControl fullWidth margin="dense">
                        <InputLabel>Région</InputLabel>
                        <Select
                            name="subType"
                            value={nomenclature.subType}
                            onChange={handleChange}
                        >
                            {subTypes.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.title}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Annuler
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    disabled={isLoading}
                >
                    {isLoading ? "Chargement..." : "Ajouter"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PostNomenclatureCard;
